import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Picture\DeletePicturesFromDossierGalleryController::__invoke
* @see app/Http/Controllers/Dossier/Picture/DeletePicturesFromDossierGalleryController.php
* @route '/api/dossier/{dossier}/gallery/picture/{picture_id}'
*/
const DeletePicturesFromDossierGalleryController = (args: { dossier: string | number | { id: string | number }, picture_id: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, picture_id: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeletePicturesFromDossierGalleryController.url(args, options),
    method: 'delete',
})

DeletePicturesFromDossierGalleryController.definition = {
    methods: ["delete"],
    url: '/api/dossier/{dossier}/gallery/picture/{picture_id}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Dossier\Picture\DeletePicturesFromDossierGalleryController::__invoke
* @see app/Http/Controllers/Dossier/Picture/DeletePicturesFromDossierGalleryController.php
* @route '/api/dossier/{dossier}/gallery/picture/{picture_id}'
*/
DeletePicturesFromDossierGalleryController.url = (args: { dossier: string | number | { id: string | number }, picture_id: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, picture_id: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
            picture_id: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
        picture_id: typeof args.picture_id === 'object'
        ? args.picture_id.id
        : args.picture_id,
    }

    return DeletePicturesFromDossierGalleryController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace('{picture_id}', parsedArgs.picture_id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Picture\DeletePicturesFromDossierGalleryController::__invoke
* @see app/Http/Controllers/Dossier/Picture/DeletePicturesFromDossierGalleryController.php
* @route '/api/dossier/{dossier}/gallery/picture/{picture_id}'
*/
DeletePicturesFromDossierGalleryController.delete = (args: { dossier: string | number | { id: string | number }, picture_id: string | number | { id: string | number } } | [dossier: string | number | { id: string | number }, picture_id: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeletePicturesFromDossierGalleryController.url(args, options),
    method: 'delete',
})

export default DeletePicturesFromDossierGalleryController